var Backbone, SharedFooterLinksTemplate, SharedFooterLoggedTemplate, SharedFooterNotLoggedTemplate, SharedFooterUSMainView, SharedFooterUSPhoneNumberView, SupportPhoneNumberCallBackView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SharedFooterUSPhoneNumberView = require('./phone_number_view');

SupportPhoneNumberCallBackView = require('../../../../../support/frontend/views/email_form/US/phone_number_call_back_view');

Backbone = require('backbone');

Backbone.$ = $;

SharedFooterLoggedTemplate = require('../../../../footer_logged.html.mustache');

SharedFooterNotLoggedTemplate = require('../../../../footer_not_logged.html.mustache');

SharedFooterLinksTemplate = require('../../../../footer_links.html.mustache');

SharedFooterUSMainView = (function(superClass) {
  extend(SharedFooterUSMainView, superClass);

  function SharedFooterUSMainView() {
    return SharedFooterUSMainView.__super__.constructor.apply(this, arguments);
  }

  SharedFooterUSMainView.prototype["class"] = 'box support-footer';

  SharedFooterUSMainView.prototype.initialize = function() {
    this.I18nScope = 'modules.shared';
    this.user = window.currentUser;
    this.isLivingSocial = window.brand === 'livingsocial';
    this.template = this.user != null ? SharedFooterLoggedTemplate : SharedFooterNotLoggedTemplate;
    return this.footerLinkTemplate = SharedFooterLinksTemplate;
  };

  SharedFooterUSMainView.prototype.render = function() {
    var ref;
    this.$el.append(toHtml(this.template, {
      id: (ref = this.user) != null ? ref.id : void 0,
      faqInsteadHelpWizard: window.faqInsteadHelpWizard,
      isLivingSocial: this.isLivingSocial
    }, this.I18nScope));
    return this.$el.find('.support_help').html(toHtml(this.footerLinkTemplate, this.user, this.I18nScope));
  };

  SharedFooterUSMainView.prototype.renderPhoneNumberView = function() {
    if (experiments.shouldDisplayCallBackOption && !window.isFAQ) {
      return this.renderPhoneNumberCallBackView();
    } else {
      return this.renderNormalPhoneNumberView();
    }
  };

  SharedFooterUSMainView.prototype.renderNormalPhoneNumberView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        var phoneNumberView;
        phoneNumberView = new SharedFooterUSPhoneNumberView();
        return phoneNumberView.render();
      };
    })(this));
  };

  SharedFooterUSMainView.prototype.renderPhoneNumberCallBackView = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        _this.phoneNumberCallBackView = new SupportPhoneNumberCallBackView({
          mainView: _this
        });
        return _this.phoneNumberCallBackView.render();
      };
    })(this));
  };

  SharedFooterUSMainView.prototype.events = {
    "click span.lnk-call-us": "renderPhoneNumberView"
  };

  return SharedFooterUSMainView;

})(Backbone.View);

module.exports = SharedFooterUSMainView;

//# sourceMappingURL=data:application/json;base64,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
